var Backbone, SharedFooterLinksTemplate, SharedFooterLoggedTemplate, SharedFooterNotLoggedTemplate, SharedFooterUSMainView, SharedFooterUSPhoneNumberView, SupportPhoneNumberCallBackView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SharedFooterUSPhoneNumberView = require('./phone_number_view');

SupportPhoneNumberCallBackView = require('../../../../../support/frontend/views/email_form/US/phone_number_call_back_view');

Backbone = require('backbone');

Backbone.$ = $;

SharedFooterLoggedTemplate = require('../../../../footer_logged.html.mustache');

SharedFooterNotLoggedTemplate = require('../../../../footer_not_logged.html.mustache');

SharedFooterLinksTemplate = require('../../../../footer_links.html.mustache');

SharedFooterUSMainView = (function(superClass) {
  extend(SharedFooterUSMainView, superClass);

  function SharedFooterUSMainView() {
    return SharedFooterUSMainView.__super__.constructor.apply(this, arguments);
  }

  SharedFooterUSMainView.prototype["class"] = 'box support-footer';

  SharedFooterUSMainView.prototype.initialize = function() {
    this.I18nScope = 'modules.shared';
    this.user = window.currentUser;
    this.isLivingSocial = window.brand === 'livingsocial';
    this.template = this.user != null ? SharedFooterLoggedTemplate : SharedFooterNotLoggedTemplate;
    return this.footerLinkTemplate = SharedFooterLinksTemplate;
  };

  SharedFooterUSMainView.prototype.render = function() {
    var ref;
    this.$el.append(toHtml(this.template, {
      id: (ref = this.user) != null ? ref.id : void 0,
      faqInsteadHelpWizard: window.faqInsteadHelpWizard,
      isLivingSocial: this.isLivingSocial
    }, this.I18nScope));
    return this.$el.find('.support_help').html(toHtml(this.footerLinkTemplate, this.user, this.I18nScope));
  };

  SharedFooterUSMainView.prototype.renderPhoneNumberView = function() {
    if (experiments.shouldDisplayCallBackOption && !window.isFAQ) {
      return this.renderPhoneNumberCallBackView();
    } else {
      return this.renderNormalPhoneNumberView();
    }
  };

  SharedFooterUSMainView.prototype.renderNormalPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        var phoneNumberView;
        phoneNumberView = new SharedFooterUSPhoneNumberView();
        return phoneNumberView.render();
      };
    })(this));
  };

  SharedFooterUSMainView.prototype.renderPhoneNumberCallBackView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        _this.phoneNumberCallBackView = new SupportPhoneNumberCallBackView({
          mainView: _this
        });
        return _this.phoneNumberCallBackView.render();
      };
    })(this));
  };

  SharedFooterUSMainView.prototype.events = {
    "click span.lnk-call-us": "renderPhoneNumberView"
  };

  return SharedFooterUSMainView;

})(Backbone.View);

module.exports = SharedFooterUSMainView;

//# sourceMappingURL=data:application/json;base64,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
